export default "__VITE_ASSET__3ad2cf09__"